<template>
  <validation-provider
    :id="$attrs.id + 'FormProvider'"
    ref="validator"
    v-slot="{ errors }"
    :name="$attrs.name"
    :vid="vid"
    :rules="rules"
  >
    <b-form-group
      :id="$attrs.id + 'FormGroup'"
      v-bind="$attrs"
      :label="labelForm"
      :label-class="['md fw-500 pb-3', labelClass]"
      :class="[{ 'has-danger': !!errors[0] }, classGroup]"
    >
      <slot name="customLabel" />
      <component
        :is="whichComponent"
        :ref="$attrs.id + 'FormInput'"
        :id="$attrs.id + 'FormInput'"
        v-model="innerValue"
        v-authenticate="authenticate"
        v-bind="$attrs"
        :class="classForm"
        v-on="$listeners"
        @blur.native="onBlur"
      >
        <!-- template slot for multiselect component for pass slot from parent to child -->
        <template slot="maxElements">
          <slot name="maxElements" />
        </template>
        <template slot="noResult">
          <slot name="noResult" />
        </template>
        <template slot="singleLabel"
                  slot-scope="props"
                  v-if="customSlot"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ labelName ? props.option[labelName] : props.option.displayName }}</span>
            <span v-if="props.option.isAdvanced"
                  class="advanceCompany"
            >{{
              resource['profilePage.Advance.Title']
            }}</span>
          </div>
        </template>
        <template slot="option"
                  slot-scope="props"
                  v-if="customSlot"
        >
          <div class="d-flex justify-content-between align-items-center"
              style="width: 75%"
          >
            <span class="ellipsis">{{ labelName ? props.option[labelName] : props.option.displayName }}</span>
            <span v-if="props.option.isAdvanced"
                  class="advanceCompany"
            >{{
              resource['profilePage.Advance.Title']
            }}</span>
          </div>
        </template>
        <template slot="afterList" >
          <slot name="afterList" />
        </template>
        <!-- ------------------ -->
        <slot />
      </component>
      <p
        v-if="!!errors[0]"
        :class="['form-control-feedback error', feedbackClass]"
      >
        {{ errors[0] }}
      </p>
    </b-form-group>
  </validation-provider>
</template>

<script>

export default {
  name: 'ValidateForm',

  props: {
    vid: {
      type: String,
      default: '',
    },
    whichComponent: {
      type: String,
      default: 'b-form-input',
    },
    customSlot: {
      type: Boolean,
      default: false,
    },
    classForm: {
      type: String,
      default: null,
    },
    classGroup: {
      type: String,
      default: null,
    },
    labelClass: {
      type: String,
      default: null,
    },
    labelForm: {
      type: String,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    feedbackClass: {
      type: String,
      default: null,
    },
    // must be included in props
    value: {
      type: [Object, String, Array, Number, Boolean],
      default: null,
    },
    authenticate: {
      type: Object,
      default() {
        return { status: '', method: '' };
      },
    },
    labelName: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },

  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    async onBlur() {
      this.$emit('blur');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/design-kit/_variable.scss";
.advanceCompany {
  font-size: 10px;
  line-height: 10px;
  font-weight: bold;
  background: #ff9b0f;
  color: #fff;
  border-radius: 4px;
  padding: 4px;
  z-index: 1;
}
.form-control {
  &:focus {
    border-width: 1px;
    border-color: $dusk;
  }
  transition: none;
}
.form-group.has-danger .form-control {
  border-color: #DE4747 !important;
  -webkit-box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0),
    inset 0 0 0 1px #DE4747;
  box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0), inset 0 0 0 1px #DE4747;
  border-width: 0px;
  transition: none;
  color:#DE4747;
}

.btn {
  font-size: 14px !important;
}
</style>
